import { z } from 'zod';

export const SServiceSlot = z
  .object({
    id: z.number(),
    date: z.string(),
    start: z.string(),
    end: z.string(),
    bpis_id: z.number(),
    bpi_id: z.number(),
    bp_id: z.number(),
    branch_id: z.number(),
    branch_name: z.string(),
    branch_address: z.string(),
    map_link: z.string().nullable(),
    service_name: z.string(),
    price: z.number(),
    status: z.string(),
    is_event: z.boolean(),
    doctor_name: z.string(),
  })
  .transform((data) => {
    const { date, start, end, ...rest } = data;
    return {
      ...rest,
      start_date: new Date(`${date}T${start}`),
      end_date: new Date(`${date}T${end}`),
    };
  });
export type TServiceSlot = z.infer<typeof SServiceSlot>;
